import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import isEmpty from 'lodash/isEmpty';
import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import ListingSection from './ListingSection';
import ListingSectionItem from './ListingSectionItem';

// former ListingPage.module.css .translationNoteCustomLineItem
// (@apply --marketplaceSmallFontStyles; no md block → plain spread)
const translationNoteCustomLineItemSx = (theme) => ({
  ...theme.mixins.marketplaceSmallFontStyles,
  color: theme.tokens.matterColorAnti,
  marginTop: '5px',
  textAlign: 'right',
});

const SectionCustomLineItemsDescriptionMaybe = ({
  customLineItems,
  isTranslated,
  listingIsLoading,
}) => {
  if (listingIsLoading)
    return (
      <ListingSection>
        <ListingSectionItem>
          <Skeleton height="160px" sx={{ my: 2, borderRadius: 2 }} variant="rounded" width="100%" />
        </ListingSectionItem>
      </ListingSection>
    );

  return !isEmpty(customLineItems) ? (
    <Grid container spacing={2}>
      <ListingSectionItem params={{ size: { lg: 12 } }}>
        <Stack width="100%">
          <Typography
            component="h3"
            mb={2}
            sx={{ textAlign: { xs: 'center', md: 'left' } }}
            variant="h4"
          >
            <FormattedMessage id="ListingPage.customLineItems.descriptionTitle" />
          </Typography>
          <Box>
            <Stack spacing={2}>
              {Object.keys(customLineItems).map((key) => {
                const { title, description } = customLineItems[key];
                return (
                  <Box key={key} mt={2}>
                    <Typography component="h4" sx={{ textAlign: { xs: 'left' } }} variant="h6">
                      {title}
                    </Typography>
                    <Typography sx={{ textAlign: { xs: 'left' } }} variant="body2">
                      {description}
                    </Typography>
                  </Box>
                );
              })}
              {isTranslated ? (
                <Box sx={translationNoteCustomLineItemSx}>
                  <FormattedMessage id="ListingPage.customLineItems.description.translation" />
                </Box>
              ) : null}
            </Stack>
          </Box>
        </Stack>
      </ListingSectionItem>
    </Grid>
  ) : null;
};

export default SectionCustomLineItemsDescriptionMaybe;
